import {useTranslation} from "react-i18next";
import {useRouteNode} from "react-router5";


function ContactsTrending({setPostTrending, contacts, root}) {
  const { t } = useTranslation();

  // sort by total trending desc
  const data = contacts.slice().sort((a, b) => b.total_counts - a.total_counts)

  let view;
  let container;

  if(root === "explore"){
    view = <p>{t('Contacts')}</p>
  }else{
    view = <p>{t('Contacts en tendances')}</p>
  }


  if(data.length !== 0){
    container = <div className={`c-contacts_contactList${ root === "explore" ? "_explore": ''}`}>
      {
        data.map(c => {
          return <Contact contact={c} key={c.id} root={root} setPostTrending={setPostTrending}/>
        })
      }
    </div>
  }else{
    container = <div className={`c-contacts_contactList${ root === "explore" ? "_explore": ''}`}>
      <p className="c-message_empty">{t('Aucun éléments à afficher')}</p>
    </div>
  }

  return (
    <>
      <div className={`c-container_contact${ root === "explore" ? "_explore": ''}`}>
        <div className="c-contacts_header">
          { view }
        </div>
        { container }
      </div>

    </>
  )
}

function Contact({contact, root, setPostTrending}){
  const { t } = useTranslation();
  const {router} = useRouteNode('explore');

  const {id,img, firstname, lastname, total_counts} = contact;

  const navigateToContact = (id) =>{
    router.navigate('explore.contact',{id:id});
  }

  let view, span, onClick;

  if(img === null || img === undefined){
    view = <span className="c-contact_img-replace">{firstname[0].toUpperCase()}{lastname[0].toUpperCase()}</span>
  }else{
    view = <img alt="" className="c-contact_img" style={{width: "40px", height: "40px"}} src={img} />
  }

  if(root === "explore"){
    span = <span className="c-contact_countNews">{total_counts}</span>
    onClick = () => navigateToContact(id)
  }else{
    span = <span className="c-contact_countNews">{total_counts} { t('articles') }{(total_counts > 1)? 's' : ''}</span>
    onClick = () => setPostTrending(id)
  }

  return (
    <div className={`c-contact_card${ root === "explore" ? "_explore": ''}`} onClick={onClick}>
      { view }
      <p className="c-contact_name">{firstname} {lastname}</p>
      { span }
    </div>
  )
}


export default ContactsTrending
